var _path, _path2, _g, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9056 10.1211C14.599 10.1211 14.3315 9.89524 14.2873 9.58274C14.2398 9.24024 14.4773 8.9244 14.8198 8.8769C15.6865 8.75524 16.3406 8.00357 16.3423 7.1269C16.3423 6.25774 15.719 5.52274 14.8598 5.3819C14.5198 5.32607 14.289 5.0044 14.3448 4.66357C14.4015 4.32274 14.7206 4.0944 15.0631 4.14857C16.5281 4.3894 17.5923 5.64274 17.5923 7.12857C17.589 8.6244 16.4715 9.90774 14.9923 10.1152C14.9631 10.1194 14.934 10.1211 14.9056 10.1211Z",
    fill: "url(#paint0_linear_1798_40767)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1798_40767",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 11,
    width: 4,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8149 11.668H18.9766V15.4426H15.8149V11.668Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1798_40767)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3843 15.4426C17.1327 15.4426 16.8952 15.2893 16.8002 15.0401C16.6768 14.7176 16.8393 14.3559 17.1618 14.2334C17.7268 14.0184 17.7268 13.7809 17.7268 13.6668C17.7268 13.3018 17.2627 13.0468 16.3477 12.9101C16.0068 12.8584 15.771 12.5409 15.8218 12.1984C15.8727 11.8568 16.1893 11.6293 16.5335 11.6734C18.5527 11.9759 18.9768 12.9243 18.9768 13.6668C18.9768 14.1201 18.7985 14.9476 17.6068 15.4018C17.5335 15.4293 17.4585 15.4426 17.3843 15.4426Z",
    fill: "url(#paint1_linear_1798_40767)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90529 13.2617C7.92529 13.2617 5.56445 13.5051 5.56445 14.6634C5.56445 15.8309 7.92529 16.0759 9.90529 16.0759C11.8853 16.0759 14.2453 15.8334 14.2453 14.6776C14.2453 13.5076 11.8853 13.2617 9.90529 13.2617ZM9.90529 17.3259C8.52279 17.3259 4.31445 17.3259 4.31445 14.6634C4.31445 12.0117 8.52279 12.0117 9.90529 12.0117C11.2878 12.0117 15.4953 12.0117 15.4953 14.6776C15.4953 17.3259 11.4345 17.3259 9.90529 17.3259Z",
    fill: "url(#paint2_linear_1798_40767)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90533 4.58203C8.49533 4.58203 7.34867 5.72953 7.34867 7.13953C7.34617 7.82286 7.60783 8.46203 8.087 8.94453C8.56617 9.42703 9.2045 9.69453 9.8845 9.69703L9.90533 10.322V9.69703C11.3153 9.69703 12.4628 8.55036 12.4628 7.13953C12.4628 5.72953 11.3153 4.58203 9.90533 4.58203ZM9.90533 10.947H9.88283C8.86617 10.9437 7.91367 10.5454 7.20033 9.82536C6.48533 9.1062 6.0945 8.1512 6.09867 7.13703C6.09867 5.04036 7.80617 3.33203 9.90533 3.33203C12.0053 3.33203 13.7128 5.04036 13.7128 7.13953C13.7128 9.2387 12.0053 10.947 9.90533 10.947Z",
    fill: "url(#paint3_linear_1798_40767)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90458 10.1212C4.87625 10.1212 4.84708 10.1196 4.81792 10.1154C3.33875 9.90789 2.22208 8.62456 2.21875 7.13039C2.21875 5.64289 3.28292 4.38956 4.74792 4.14873C5.09875 4.09373 5.40958 4.32456 5.46625 4.66373C5.52208 5.00456 5.29125 5.32623 4.95125 5.38206C4.09208 5.52289 3.46875 6.25789 3.46875 7.12873C3.47042 8.00373 4.12458 8.75623 4.99042 8.87706C5.33292 8.92456 5.57042 9.24039 5.52292 9.58289C5.47875 9.89539 5.21125 10.1212 4.90458 10.1212Z",
    fill: "url(#paint4_linear_1798_40767)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42683 15.4424C2.35266 15.4424 2.27766 15.4291 2.20433 15.4016C1.01183 14.9466 0.833496 14.1191 0.833496 13.6666C0.833496 12.9249 1.25766 11.9758 3.27766 11.6733C3.62183 11.6299 3.93683 11.8566 3.9885 12.1983C4.03933 12.5408 3.8035 12.8583 3.46266 12.9099C2.54766 13.0466 2.0835 13.3016 2.0835 13.6666C2.0835 13.7808 2.0835 14.0174 2.64933 14.2333C2.97183 14.3558 3.13433 14.7174 3.011 15.0399C2.916 15.2891 2.6785 15.4424 2.42683 15.4424Z",
    fill: "url(#paint5_linear_1798_40767)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40767",
    x1: 15.9368,
    y1: 4.14062,
    x2: 15.9368,
    y2: 10.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40767",
    x1: 17.3959,
    y1: 11.668,
    x2: 17.3959,
    y2: 15.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1798_40767",
    x1: 9.90487,
    y1: 12.0117,
    x2: 9.90487,
    y2: 17.3259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1798_40767",
    x1: 9.90573,
    y1: 3.33203,
    x2: 9.90573,
    y2: 10.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1798_40767",
    x1: 3.87386,
    y1: 4.14062,
    x2: 3.87386,
    y2: 10.1212,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1798_40767",
    x1: 2.41444,
    y1: 11.668,
    x2: 2.41444,
    y2: 15.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B6B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsIcon);
export default __webpack_public_path__ + "static/media/contacts-icon.380d8aa562dc69c61f960c9f06f1163a.svg";
export { ForwardRef as ReactComponent };